import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import {
  formatOlympiadSelectLabel,
  OlympiadSelectItem,
} from '../utils/multilang-names.util';

@Pipe({
  name: 'olympiadSelectLabel',
  standalone: true,
})
export class OlympiadSelectLabelPipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  transform(item: OlympiadSelectItem | null | undefined): string {
    return formatOlympiadSelectLabel(item, this.transloco.getActiveLang());
  }
}
